import { createContext, ReactNode, useContext, useMemo, useState } from "react";

export interface InboxReplyContextValue {
  isReplying: boolean;
  setIsReplying: (isReplying: boolean) => void;
  isDirty: boolean;
  markDirty: () => void;
  clearDirty: () => void;
}

interface InboxReplyContextProps {
  children: ReactNode;
}

const InboxReplyContext = createContext<InboxReplyContextValue | undefined>(undefined);

export function InboxReplyContextProvider({ children }: InboxReplyContextProps) {
  const [isReplying, setIsReplying] = useState<boolean>(false);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const markDirty = () => setIsDirty(true);
  const clearDirty = () => setIsDirty(false);

  const value = useMemo(
    () => ({
      isReplying,
      setIsReplying,
      isDirty,
      markDirty,
      clearDirty,
    }),
    [isReplying, setIsReplying, isDirty],
  );

  return (
    <InboxReplyContext.Provider value={value}>
      {children}
    </InboxReplyContext.Provider>
  );
}

export const useInboxReplyContext = () => {
  const context = useContext(InboxReplyContext);
  if (!context) {
    throw new Error(
      "useInboxReplyContext must be used within an InboxReplyContextProvider",
    );
  }
  return context;
};